import { useState } from "react";
import { styled } from "@mui/material/styles";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
// components
import Page from "../../components/Page";
import { LoginForm } from "../../components/authentication/login";
import Logo from "src/components/Logo";
import { MotionContainer } from "src/components/animate";
import useResponsive from "../../hooks/useResponsive";
import { DivLoop } from "./DivLoop";
import { AuthSideImage } from "./AuthSideImage";

const RootStyle = styled(Page)(({ theme }) => ({
  padding: "0px!important",
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: "100%",
  margin: "auto",
  display: "flex",
  height: "100vh",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
}));

// ----------------------------------------------------------------------
const TITLES = [
  "Get Started",
  "Confirm account",
  "More Options",
  "Finish signing up",
];
export default function Login() {
  const params = useParams();
  const [steps, setSteps] = useState(0);
  const isNotDesktop = useResponsive("up", "md");
  return (
    <RootStyle title="Login to Dashboard">
      <MotionContainer>
        <ContentStyle>
          <Stack
            direction="column"
            alignItems={{ md: "start", xs: "center" }}
            justifyContent="space-around"
            sx={{
              flexGrow: 1,
              flexShrink: 0,
              width: { lg: "40%", xs: 1 },
              maxWidth: { md: "40%", xs: 1 },
              mr: { md: "10%", xs: 0 },
              height: 1,
              p: { md: 5, xs: 2 },
              px: { lg: 8, md: 4 },
              pb: { lg: 5, xs: 0 },
              overflow: "scroll",
            }}
            spacing={2}
          >
            <Stack
              sx={{ width: 1 }}
              spacing={2}
              alignItems={{ md: "start", xs: "center" }}
              justifyContent={{ md: "start", xs: "center" }}
            >
              <Logo isText />
              {!isNotDesktop && <Divider flexItem />}
            </Stack>
            <Stack
              direction="row"
              sx={{ width: 1 }}
              alignItems="center"
              justifyContent={{ md: "start", xs: "center" }}
              spacing={4}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  fontSize: 24,
                  fontWeight: 500,
                  color: "rgba(65, 177, 26, 1)",
                  flexShrink: 0,
                }}
                gutterBottom
              >
                {TITLES[steps]}
              </Typography>
              <Box sx={{ maxWidth: { md: 1, xs: 200 } }}>
                <DivLoop />
              </Box>
            </Stack>
            <LoginForm
              setSteps={setSteps}
              steps={steps}
              referrer={(params && params.ref) || ""}
            />
            <Typography
              variant="body2"
              sx={{
                textAlign: "center",
                width: 1,
                color: "rgba(0, 0, 0, 1)",
                fontWeight: 500,
              }}
            >
              &copy;{new Date().getFullYear()} Afritas
            </Typography>
          </Stack>
          {isNotDesktop && <AuthSideImage />}
        </ContentStyle>
      </MotionContainer>
    </RootStyle>
  );
}
